import { ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export const SectionHeader = ({
  icon = null,
  sticky = false,
  title = null,
  subtitle = null,
  buttons = null,
}: {
  icon?: ReactNode;
  sticky?: boolean;
  title?: ReactNode;
  subtitle?: ReactNode;
  buttons?: ReactNode;
}): ReactElement => {
  return (
    <div
      className={twMerge(
        "flex flex-row items-center items-start pb-4 md:justify-between",
        sticky &&
          "sticky top-[52px] border-b-1 border-solid border-gray-100 bg-white p-2",
      )}
    >
      <div className={"flex items-center"}>
        {icon && icon}
        <div className={twMerge(icon && "ml-4")}>
          {title && title}
          {subtitle && subtitle}
        </div>
      </div>
      {buttons && <div className={"ml-auto"}>{buttons}</div>}
    </div>
  );
};
